import {useNavigate} from "react-router-dom";

import {Box, Button, Container} from "@mui/material";
import {styled} from "@mui/system";
import {grey} from '@mui/material/colors';

import TodayIcon from "@mui/icons-material/Today";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FactCheckIcon from "@mui/icons-material/FactCheck";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import HistoryIcon from "@mui/icons-material/History";

import {NAVIGATION_PATHS} from "../config/NavigationPaths";

import useOpenUrlInNewTab from "../hooks/useOpenUrlInNewTab";
import {useCurrentUser} from "../hooks/useCurrentUser";

import WFEImage from "../resources/image/WFE-Logo.png";

const HomeContainer = styled(Container)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "92vh",
  minWidth: "100vw",
  backgroundColor: "rgb(245, 247, 250)",
}));

const menuOptionsStyle = {
  display: "flex",
  flexDirection: {xs: "column", sm: "row"},
  justifyContent: "center",
  alignItems: "center",
  gap: "1rem",
  marginTop: "1rem",
  marginBottom: "1rem",
};

const buttonStyle = {
  color: "black",
  display: "flex",
  justifyContent: {xs: "flex-start", sm: "center"},
  borderRadius: "0.8rem",
  paddingLeft: {xs:"1rem",sm:'0rem'},
  boxShadow: [
    "0rem -0.063rem 0.125rem rgba(0,0,0,0.08)",
    "0rem 0.25rem 0.375rem -0.063rem rgba(0,0,0,0.48)",
    "0rem 0.125rem 0.25rem -0.063rem rgba(0,0,0,0.03)"
  ].join(", "),
  textTransform: "none",
  minWidth: "10.34rem",
  border: "none",
  '&:hover': {
    backgroundColor: grey[100],
    boxShadow: 'none',
  },
};

const Card = styled(Box)(() => ({
  padding: "1rem",
  borderRadius: "2rem",
  backgroundColor: "#ffffff",
  textAlign: "center",
  maxWidth: 600,
  width: "100%",
}));

export default function HomePage() {

  const {currentUser} = useCurrentUser();
  const navigate = useNavigate();
  const openUrlInNewTab = useOpenUrlInNewTab();

  const RESOURCES_URL = process.env.REACT_APP_PERFORMER_RESOURCE_PAGE_PATH;

  const canTeach = currentUser?.canTeach || false;
  
  function handleMySessionsClick() {
    navigate(NAVIGATION_PATHS.MY_SESSIONS);
  }

  function handleMyAvailabilityClick() {
    navigate(NAVIGATION_PATHS.MY_AVAILABILITY);
  }

  function handleMyResourcesClick(){
    openUrlInNewTab(RESOURCES_URL);
  }

  function handleMyHistoryClick(){
    navigate(NAVIGATION_PATHS.MY_HISTORY)
  }

  return (
    <HomeContainer>
      <Card>
        <Box sx={{marginBottom: 2, marginTop: 2}}>
          <img src={WFEImage} alt="World Family" style={{width: '6.875rem', height: 'auto', marginLeft:'0.438rem'}}/>
        </Box>
        <Box sx={menuOptionsStyle}>
          {
            canTeach
            &&
            <Button onClick={handleMySessionsClick} sx={buttonStyle} >
              <TodayIcon sx={{marginRight: 1}} />
              My Sessions
            </Button>
          }
          {
            canTeach
            &&
            <Button onClick={handleMyHistoryClick} sx={buttonStyle}>
              <HistoryIcon sx={{marginRight: 1}}/>
              My History
            </Button>
          }
        </Box>
        <Box sx={menuOptionsStyle}>
          {
            canTeach
            &&
            <Button onClick={handleMyAvailabilityClick} sx={buttonStyle}>
              <FactCheckIcon sx={{marginRight: 1}}/>
              My Availability
            </Button>
          }
          {
            canTeach
            &&
            <Button onClick={handleMyResourcesClick} sx={buttonStyle} endIcon={<OpenInNewIcon sx={{marginLeft: -0.5}}/>}>
              <LocalLibraryIcon sx={{marginRight: 1}}/>
              My Resources
            </Button>
          }
        </Box>
      </Card>     
    </HomeContainer>
  );
}